var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../components/atoms/Dialog';
import Button from '../components/atoms/BaseButton';
var ConfirmationActionType;
(function (ConfirmationActionType) {
    ConfirmationActionType["OPEN"] = "OPEN";
    ConfirmationActionType["CLOSE"] = "CLOSE";
})(ConfirmationActionType || (ConfirmationActionType = {}));
var initialState = {
    open: false,
    title: '',
    body: '',
    buttonLabels: {
        confirm: '',
        close: '',
    },
    onConfirmed: function () {
        return;
    },
};
var ConfirmationStateContext = React.createContext(initialState);
var ConfirmationDispatchContext = React.createContext(null);
var reducer = function (state, action) {
    switch (action.type) {
        case ConfirmationActionType.OPEN: {
            return __assign(__assign(__assign({}, state), action.payload), { open: true });
        }
        case ConfirmationActionType.CLOSE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};
var ConfirmationProvider = function (_a) {
    var children = _a.children;
    var initializer = function (state) { return state; };
    var _b = React.useReducer(reducer, initialState, initializer), state = _b[0], dispatch = _b[1];
    var t = useTranslation().t;
    var handleConfirmed = React.useCallback(function () {
        if (state.onConfirmed)
            state.onConfirmed();
        dispatch({ type: ConfirmationActionType.CLOSE });
    }, [state, dispatch]);
    var handleClose = React.useCallback(function () {
        dispatch({ type: ConfirmationActionType.CLOSE });
    }, [dispatch]);
    var actions = React.useMemo(function () {
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: handleConfirmed, color: "primary" }, ((_a = state.buttonLabels) === null || _a === void 0 ? void 0 : _a.confirm) || t('buttons.yes')),
            React.createElement(Button, { onClick: handleClose }, ((_b = state.buttonLabels) === null || _b === void 0 ? void 0 : _b.close) || t('buttons.no'))));
    }, [handleClose, handleConfirmed, state.buttonLabels, t]);
    return (React.createElement(ConfirmationStateContext.Provider, { value: state },
        React.createElement(ConfirmationDispatchContext.Provider, { value: dispatch },
            children,
            React.createElement(Dialog, { title: state.title, open: state.open, onClose: handleClose, actions: actions }, state.body))));
};
function useConfirm() {
    var dispatch = React.useContext(ConfirmationDispatchContext);
    if (!dispatch) {
        throw new Error('ConfirmationDispatchContext undefined');
    }
    return function (title, body, onConfirmed, buttonLabels) {
        dispatch({
            type: ConfirmationActionType.OPEN,
            payload: {
                title: title,
                body: body,
                buttonLabels: buttonLabels,
                onConfirmed: onConfirmed,
            },
        });
    };
}
export { ConfirmationProvider, ConfirmationActionType, useConfirm };
